var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkPlus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.125C8.28403 2.125 8.51429 2.36964 8.51429 2.67143V7.95357H13.4857C13.7697 7.95357 14 8.19822 14 8.5C14 8.80178 13.7697 9.04643 13.4857 9.04643H8.51429V14.3286C8.51429 14.6304 8.28403 14.875 8 14.875C7.71597 14.875 7.48571 14.6304 7.48571 14.3286V9.04643H2.51429C2.23025 9.04643 2 8.80178 2 8.5C2 8.19822 2.23025 7.95357 2.51429 7.95357H7.48571V2.67143C7.48571 2.36964 7.71597 2.125 8 2.125Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkPlus);
export default __webpack_public_path__ + "static/media/dark-plus.03aa0412efe552f16ca496a17c5fae90.svg";
export { ForwardRef as ReactComponent };